module.exports = __webpack_public_path__ + "img/p2000.2dba7d10.svg";